import { useState } from "react";
import EmployeeLogController from "./EmployeeLogController";
import useFormattedDate from "../../../../context/useFormattingUtils";
import { ReusableDateInput } from "../../../common/ReusableComponent/ReusableInput";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import SalesInvoiceTable from "../../AppPAges/Dashboard/Invoice/SalesInvoiceTable";
import EmployeeFaceTooltip from "./EmployeeImageTooltip";
const EmployeeLogView = () => {
  const { GetPaginatedData } = useApi();
  const {
    employeeLogs,
    employeeLogsDateRange,
    selectedEmployee,
    selectedEmployeeObj,
    startDate,
    endDate,
    handleEmployeeChange,
    handleStartDateChange,
    handleEndDateChange,
    fetchEmployeeLogs,
    handleDelete,
    clearFilters,
    getEmployeeLogData,
    debouncedGetEmployeeLogData,
    isLoadingData,
    totalPages,
    totalCount
  } = EmployeeLogController();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const handleClear = () => {
    clearFilters();
  };


  const { formatDate } = useFormattedDate();


  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    debouncedGetEmployeeLogData(1, term);
  };


  const handlePageChange = (page) => {
    setCurrentPage(page);
    getEmployeeLogData(page, searchTerm);
  };


  const formatDateOnly = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString([], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };


  const formatTime = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    fetchEmployeeLogs();
  };


  const columns1 = [
    { header: "Employee", field: "employee_name" },
    { header: "Date", field: "date_time" },
    { header: "Time", field: "date_time_formatted" },
    { header: "Status", field: "clocked_in_status" },
    { 
      header: "Face Image", 
      field: "face_image",
      render: (item) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <EmployeeFaceTooltip imagePath={item.face_image} />
        </div>
      )
    },
  ];


  const formattedEmployeeLogs = (employeeLogs || []).map(item => ({
    ...item,
    created_at_formatted: formatDate(item.created_at),
    date_time: formatDateOnly(item.date_time),
    date_time_formatted: formatTime(item.date_time),
    clocked_in_status: item.is_clocked_in ? "Clocked In" : "Clocked Out",
  }));


  return (
    <div className="responsive-box">
      <div className="employee-header">
        <div className="employee-title">Employee Logs</div>
      </div>
      <div className="d-flex justify-content-center align-items-center mb-4 mt-4">
        <form
          onSubmit={handleSubmit}
          className="d-flex align-items-center"
          style={{ gap: "15px", flexWrap: "wrap", width: "100%", maxWidth: "1200px" }}
        >
          <div className="d-flex flex-column" style={{ minWidth: "240px", flex: "1" }}>
            <PaginatedSearchSelect
            
              api="user"
              GetPaginatedData={GetPaginatedData}
              getOptionLabel={(opt) => `${opt.first_name} ${opt.last_name || ""}`}
              onSelect={(opt) => handleEmployeeChange(opt)}
              placeholder="Select an Employee"
              value={selectedEmployeeObj}
              style={{ width: "100%" }}
              filterFn={(user) => user.ms_role_name === "store employee" || user.ms_role_name === "store manager"}
            />
          </div>
          <div style={{ minWidth: "200px", flex: "1" }}>
            <ReusableDateInput
              label="Start Date:"
              value={startDate}
              onChange={handleStartDateChange}
              placeholder="Select Start Date"
            />
          </div>
          <div style={{ minWidth: "200px", flex: "1" }}>
            <ReusableDateInput
              label="End Date:"
              value={endDate}
              onChange={handleEndDateChange}
              placeholder="Select End Date"
            />
          </div>
          <button
            type="submit"
            id="search-button"
            disabled={!selectedEmployee || !startDate || !endDate}
            style={{
              minWidth: "120px",
              height: "52px",
              padding: "5px 15px",
              fontSize: "16px",
              fontWeight: "700",
              color: "#f4ffee",
              backgroundColor: "#4a5546",
              border: "none",
              borderRadius: "40px",
              cursor: "pointer",
              marginBottom: "5px"
            }}
          >
            Search
          </button>
          <button
            type="button"
            id="clear-button"
            onClick={handleClear}
            style={{
              minWidth: "120px",
              height: "52px",
              padding: "5px 15px",
              fontSize: "16px",
              fontWeight: "700",
              color: "#4a5546",
              backgroundColor: "#E8ECE6",
              border: "1px solid #4a5546",
              borderRadius: "40px",
              cursor: "pointer",
              marginBottom: "5px"
            }}
          >
            Clear
          </button>
        </form>
      </div>
      {selectedEmployee && startDate && endDate ? (
        <div className="overflow-x-auto mt-4">
          <table
            className="data-table custom-table"
            style={{
              borderRadius: "20px 20px 0 0",
              border: "1px solid #EBEAF2",
              borderCollapse: "separate",
              borderSpacing: 0,
              overflow: "hidden",
            }}
          >
            <thead className="table-header">
              <tr>
                <th>No</th>
                <th></th>
                <th>Employee Name</th>
                <th>Date</th>
                <th>Clock In</th>
                <th>Clock Out</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {(employeeLogsDateRange && employeeLogsDateRange.length > 0) ? (
                employeeLogsDateRange.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="p-3 border-b">{index + 1}</td>
                    <td className="p-3 border-b">
                      <EmployeeFaceTooltip imagePath={item?.face_image} />
                    </td>
                    <td className="p-3 border-b">{item?.employee_name}</td>
                    <td className="p-3 border-b">{item.date}</td>
                    <td className="p-3 border-b" style={{ color: "green", fontWeight: 600 }}>
                      {item.clock_in || "-"}
                    </td>
                    <td className="p-3 border-b" style={{ color: "red", fontWeight: 600 }}>
                      {item.clock_out || "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={6}
                    className="p-4 text-center text-gray-500 font-medium"
                  >
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <SalesInvoiceTable
          data={formattedEmployeeLogs}
          columns={columns1}
          showAction={false}
          onDelete={handleDelete}
          showFooter={true}
          loading={isLoadingData}
          showNo={false}
          currentPage={currentPage}
          totalCount={totalCount}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          searchTerm={searchTerm}
          onSearch={handleSearch}
        />
      )}
    </div>
  );
};
export default EmployeeLogView;